var _mask, _path, _path2, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioFillNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_769_22052)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_769_22052",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#D3135A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C4.68629 14 2 11.3137 2 8H-2C-2 13.5228 2.47715 18 8 18V14ZM14 8C14 11.3137 11.3137 14 8 14V18C13.5228 18 18 13.5228 18 8H14ZM8 2C11.3137 2 14 4.68629 14 8H18C18 2.47715 13.5228 -2 8 -2V2ZM8 -2C2.47715 -2 -2 2.47715 -2 8H2C2 4.68629 4.68629 2 8 2V-2Z",
    fill: "#D3135A",
    mask: "url(#path-1-inside-1_769_22052)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_769_22052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_769_22052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5C7.025 11.5 6.19792 11.1604 5.51875 10.4813C4.83958 9.80208 4.5 8.975 4.5 8C4.5 7.025 4.83958 6.19792 5.51875 5.51875C6.19792 4.83958 7.025 4.5 8 4.5C8.975 4.5 9.80208 4.83958 10.4813 5.51875C11.1604 6.19792 11.5 7.025 11.5 8C11.5 8.975 11.1604 9.80208 10.4813 10.4813C9.80208 11.1604 8.975 11.5 8 11.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_769_22052",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_769_22052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_769_22052",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioFillNew);
export default __webpack_public_path__ + "static/media/radio-fill-new.2aa0f122010c8e5260f649945002523b.svg";
export { ForwardRef as ReactComponent };